"use client"

import { useLanguage } from "@/lib/i18n"
import { useEffect, useState } from "react"
import { motion } from "framer-motion"

export function LanguageToggle() {
  const { locale, setLocale } = useLanguage()
  const [mounted, setMounted] = useState(false)

  useEffect(() => {
    setMounted(true)
  }, [])

  if (!mounted) {
    return <div className="w-10 h-10 rounded-full bg-[var(--color-bg-tertiary)]" />
  }

  const isEN = locale === "en"

  return (
    <motion.button
      onClick={() => setLocale(isEN ? "zh" : "en")}
      className="relative w-10 h-10 rounded-full flex items-center justify-center transition-all duration-300 hover:bg-[var(--color-bg-tertiary)] focus-ring group"
      whileHover={{ scale: 1.08 }}
      whileTap={{ scale: 0.92 }}
      aria-label={isEN ? "切換至中文" : "Switch to English"}
      title={isEN ? "切換至中文" : "Switch to English"}
    >
      {/* Subtle glow on hover */}
      <span
        className="absolute inset-0 rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none"
        style={{
          background: "radial-gradient(circle, var(--color-accent-gold) 0%, transparent 70%)",
          filter: "blur(8px)",
          transform: "scale(0.8)",
        }}
      />
      {/* EN label */}
      <motion.span
        className="absolute text-xs font-medium tracking-wide"
        style={{
          fontFamily: "var(--font-mono)",
          color: "var(--color-accent-gold)",
        }}
        initial={false}
        animate={{
          scale: isEN ? 1 : 0,
          opacity: isEN ? 1 : 0,
          rotate: isEN ? 0 : -90,
        }}
        transition={{ duration: 0.3, ease: [0.22, 1, 0.36, 1] }}
      >
        EN
      </motion.span>
      {/* 中 label */}
      <motion.span
        className="absolute text-sm font-medium"
        style={{
          color: "var(--color-accent-gold)",
        }}
        initial={false}
        animate={{
          scale: isEN ? 0 : 1,
          opacity: isEN ? 0 : 1,
          rotate: isEN ? 90 : 0,
        }}
        transition={{ duration: 0.3, ease: [0.22, 1, 0.36, 1] }}
      >
        中
      </motion.span>
    </motion.button>
  )
}
